var HashMap = require("../collections/hashMap.js");
var InstanceBuilder = require("./instanceBuilder/instanceBuilder.js");
var AbstractInstance = require("./instanceBuilder/abstractInstance.js");

// Root extension to give each node in this root a globally unique id
var GlobalUid = {
    initGlobalUid: function(){
        this.nodeMap = new HashMap(); // TODO: maybe this nodeMap is unnecessary

        this.onAdd("__setGuid", function(node){ // when a treenode is added to this root, give it a guid (if it wasn't already added, e.g. by dejsonify)
            if (!this.nodeMap.contains(node.$id)) {
                if (node instanceof AbstractInstance && !(node instanceof InstanceBuilder)) {
                    var builder = node.getBuilder();
                    var ancestorDepth = builder.ancestor().$id.split("/").length;
                    this.registerNode(node, builder.$id + "/" + node.template().$id.split("/").slice(ancestorDepth - 1).join("/"));
                } else this.registerNode(node, GlobalUid.generateGuid());
            }
        });

        this.onRemove("__removeGuid", function(node){
            this.nodeMap.remove(node.$id);
            // delete node.$id; // TODO: see if we can bring this back somehow: problem is that we need this id while jsonifying the remove event while this delete id happens before
        });

        this.hasGlobalUid = true;
    },

    registerNode: function(node, id){
        node.$id = id;
        this.nodeMap.put(id, node);
    },

    // TODO: not very clean!
    registerInstances: function(builder){
        var self = this;
        if (builder.isRegistered) return;
        function registerInstancesFrom(node){
            node.forEachInstance(function(instance){
                var ancestorDepth = builder.ancestor().$id.split("/").length;
                var instanceId = builder.$id + "/" + instance.template().$id.split("/").slice(ancestorDepth - 1).join("/");
                self.registerNode(instance, instanceId);
                registerInstancesFrom(instance);
            });
        }
        registerInstancesFrom(builder);
        builder.isRegistered = true;    // TODO: not clean! try to avoid setting this flag!
    },

    generateGuid: function(){
        var base = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";    // base 62
        var id = "";

        // add time stamp to id (encoded in base 62)
        var time = (new Date()).getTime();
        while(time > 0){
            id = base[time % base.length] + id;
            time = Math.floor(time / base.length);
        }

        //add random part (6 base 62 chars)
        id += "-";
        for (var i = 0; i < 6; i++){
            id += base[Math.random()*base.length|0];
        }
        return id;
    },

    copyIds: function(target, source) {
        var self = this;
        if(!target || !target.isObservableTreeNode) return;
        target.$id = source.$id;
        target.collections.forEach(function(name, col) {
            var sourceCol = source.collections.get(name);
            switch(sourceCol.getType()){
            case "value":
                self.copyIds(col(), sourceCol());
                break;
            case "map":
                var hashes = new HashMap();
                sourceCol.forEach(function(sourceKey) {
                    if(sourceKey.isObservableTreeNode) {
                        var hash = self.hashify(sourceKey);
                        // console.assert(!hashes.contains(hash) || sourceKey === hashes.get(hash), "Duplicate hash");
                        hashes.put(hash, sourceKey);
                    }
                });
                col.forEach(function(key, val) {
                    var sourceKey;
                    if(key.isObservableTreeNode)
                        sourceKey = hashes.get(self.hashify(key));
                    else
                        sourceKey = key;
                    console.assert(key != undefined);
                    var sourceVal = sourceCol.get(sourceKey);
                    self.copyIds(val, sourceVal);
                });
                break;
            case "list":
                col.forEach(function(key, val) {
                    if(key.isObservableTreeNode) throw new Error("Not implemented");
                    var sourceVal = sourceCol.get(key);
                    self.copyIds(val, sourceVal);
                });
                break;
            case "set":
                var hashes = new HashMap();
                sourceCol.forEach(function(sourceVal) {
                    var hash = self.hashify(sourceVal);
                    // console.assert(!hashes.contains(hash) || sourceVal === hashes.get(hash), "Duplicate hash");
                    hashes.put(hash, sourceVal);
                });
                col.forEach(function(val) {
                    var sourceVal = hashes.get(self.hashify(val));
                    console.assert(sourceVal != undefined);
                    self.copyIds(val, sourceVal);
                });
                break;
            default:
                throw new Error("Unexpected");
            }
        }, true, true);
    }
};

module.exports = GlobalUid;